import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
        height: "100%"
    },
}));

function FlexCrudScreenHeaderLayout ( props ) {

    const classes = useStyle();

    const { children, className, ...others } = props;
    
    return (

        <header className={classes.root}>
            {
                React.Children.map(children, ( child => 
                    React.cloneElement(child, others) ) )
            }
        </header>
    )

}


export default FlexCrudScreenHeaderLayout;

